import throttle from "./directive";

const install = function(Vue) {
  Vue.directive("click-throttle", throttle);
};

if (typeof window !== "undefined" && window.Vue) {
  window["click-throttle"] = throttle;
  Vue.use(install); // eslint-disable-line
}

throttle.install = install;
export default throttle;
